import { NextSeo } from "next-seo";
import Head from "next/head";
import { BaseMetaSeo } from "@components/Seo/base";
import { STATIC_DOMAIN } from "@/constants/environment";

export interface IogImageUrl {
  url: string;
  width?: number;
  height?: number;
  alt?: string;
}

interface IMetaProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: IogImageUrl;
  noindex?: boolean;
  nofollow?: boolean;
  additionalMetaTags?: { name: string; content: string }[];
}

const Meta = ({
  ogImage,
  noindex,
  nofollow,
  additionalMetaTags,
  title,
  description,
  canonical,
}: IMetaProps) => {
  const ogImages: IogImageUrl = {
    url: `${STATIC_DOMAIN}/images/thumb-image.png`,
    width: 720,
    height: 540,
    alt: BaseMetaSeo.metaTitle,
  };

  return (
    <>
      <Head>
        <meta charSet="UTF-8" key="charset" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <link
          rel="shortcut icon"
          href={`${STATIC_DOMAIN}/images/favicon.ico`}
        />
      </Head>
      <NextSeo
        noindex={noindex}
        nofollow={nofollow}
        additionalMetaTags={additionalMetaTags}
        title={title}
        description={description}
        canonical={canonical}
        openGraph={{
          title: title,
          description: description,
          url: canonical,
          site_name: BaseMetaSeo.siteName,
          images: [ogImage ? ogImage : ogImages],
        }}
      />
    </>
  );
};

export { Meta };
